import { MAIN_ADMIN_ROUTE } from '@config'
import { ADMIN_ROUTES, ROUTES } from '@constants/app_routes'
import { adminPrefix } from '@utils/navigation_utils'

export const adminTripRoutes = [
  adminPrefix(ADMIN_ROUTES.ADMIN_TRIPS_CREATE),
  adminPrefix(ADMIN_ROUTES.ADMIN_TRIPS_EDIT),
  adminPrefix(ADMIN_ROUTES.ADMIN_TRIPS)
]

export const adminRoutes = adminTripRoutes.concat([
  MAIN_ADMIN_ROUTE,
  adminPrefix(ADMIN_ROUTES.ADMIN_API),
  adminPrefix(ADMIN_ROUTES.ADMIN_NMEA),
  adminPrefix(ADMIN_ROUTES.ADMIN_CREW),
  adminPrefix(ADMIN_ROUTES.ADMIN_FOOD_MANAGEMENT),
  adminPrefix(ADMIN_ROUTES.ADMIN_GALLERY),
  adminPrefix(ADMIN_ROUTES.ADMIN_MODBUS_ADDRESS),
  adminPrefix(ADMIN_ROUTES.ADMIN_MODBUS_CONFIG),
  adminPrefix(ADMIN_ROUTES.ADMIN_GALLERY_VIEW),
  adminPrefix(ADMIN_ROUTES.ADMIN_PAGES_CONFIG),
  adminPrefix(ADMIN_ROUTES.ADMIN_SETTINGS),
  adminPrefix(ADMIN_ROUTES.ADMIN_TRANSLATIONS),
  adminPrefix(ADMIN_ROUTES.ADMIN_TRIPS),
  adminPrefix(ADMIN_ROUTES.ADMIN_TRIPS_EDIT),
  adminPrefix(ADMIN_ROUTES.ADMIN_TRIPS_CREATE),
  adminPrefix(ADMIN_ROUTES.ADMIN_NOTIFICATION),
  adminPrefix(ADMIN_ROUTES.ADMIN_IMAGE_UPLOAD),
  adminPrefix(ADMIN_ROUTES.ADMIN_WIDGET),
  adminPrefix(ADMIN_ROUTES.ADMIN_INDEXJSON),
  adminPrefix(ADMIN_ROUTES.ADMIN_PAGESJSON),
  adminPrefix(ADMIN_ROUTES.ADMIN_WIDGET_LAYOUT),
  adminPrefix(ADMIN_ROUTES.ADMIN_AGENDA),
  adminPrefix(ADMIN_ROUTES.ADMIN_GAUGE_LAYOUT),
  adminPrefix(ADMIN_ROUTES.ADMIN_THEME),
  adminPrefix(ADMIN_ROUTES.ADMIN_ERRORS),
  adminPrefix(ADMIN_ROUTES.ADMIN_PAGES_SETTINGS),
  adminPrefix(ADMIN_ROUTES.ADMIN_YACHT_INFORMATION),
  adminPrefix(ADMIN_ROUTES.ADMIN_YACHT_GALLERY_VIEW),
  adminPrefix(ADMIN_ROUTES.ADMIN_LIVE_LOG_VIEWER),
  adminPrefix(ADMIN_ROUTES.ADMIN_INDEXJSON)
])

export const routesWithoutSlideShow = adminRoutes.concat([ROUTES.PINCODE])

export const pagesWithoutFooter = adminRoutes.concat([ROUTES.HOME, ROUTES.PINCODE])

export const pagesUnderDashboard = [ROUTES.THREE_D]

export const pagesUnderOvalDashboard = [...pagesUnderDashboard, ROUTES.MAP]

export const noRedirectRoutes = [
  adminPrefix(ADMIN_ROUTES.ADMIN_INDEXJSON),
  adminPrefix(ADMIN_ROUTES.ADMIN_PAGESJSON),
  adminPrefix(ADMIN_ROUTES.ADMIN_THEME)
]
